import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import CustomerProductDetailFormSchema from './customerProductDetailDialog.form';

import { ICustomerProductDetailDialogProperties } from './customerProductDetailDialog.properties';
import CustomerProductDetailSummarySchema from './customerProductDetailDialog.summaryTable.schema';
import SummaryTable from 'components/common/SummaryTable';

const CustomerProductDetailDialog = (props: ICustomerProductDetailDialogProperties): JSX.Element => {

  const { open, loading = false, data, summaryData, onCancel, onOk, values, resetForm } = props;

  const formSchema = CustomerProductDetailFormSchema.CustomerProductDetail;

  React.useEffect(
    () => {
      resetForm();
    },
    [open]);

  const getActions = () => {
    return [
      {
        title: 'Ok',
        iconName: 'CheckCircle',
        listener: async () => {
          if (onOk) {
            onOk(values);
          }
        }
      },
      {
        title: 'Cancel',
        isDefault: true,
        iconName: 'Cancel',
        listener: () => {
          if (onCancel) {
            onCancel();
          }
        },
      },
    ];
  };

  return (
    <div>
      <FormViewModal
        open={open}
        loading={loading}
        title='Customer Product Detail'
        formProps={{
          formSchema: formSchema,
          initialValues: data,
          style: { width: 'auto', height: '400px' },
          summaryTableRenderer: () => <SummaryTable loadingCustomerProductDetailSummary={false}
            customerProductDetailSummary={summaryData}
            data={
              CustomerProductDetailSummarySchema
            }
          />
        }}
        actions={getActions()}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
      />
    </div>
  );
};

export default CustomerProductDetailDialog;
